import React from 'react'

const RightArrow = ({ width, height }) => {
  return (
    <svg
      width={width || '16'}
      height={height || '17'}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M5.34996 14.7728L4.16663 13.5895L9.64996 8.10612L4.16663 2.62279L5.34996 1.43945L12.0166 8.10612L5.34996 14.7728Z"
        fill="#4D566E"
      />
    </svg>
  )
}

export default RightArrow
